export interface VideoItem {
  id: string;
  title: string;
  cover: string;
  duration: string;
  year: number;
  category: string;
  region: string;
  perspective: string;
  tags: string[];
  uploadDate: string;
  views: number;
  resolution: string;
  description: string;
  featured: boolean;
}

export const videos: VideoItem[] = [
  {
    id: "v01",
    title: "深夜便利店的城市漫游",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20quiet%20neon%20lit%20convenience%20store%20street%20corner%20at%20midnight%20with%20rain%20wet%20pavement%20reflections%20moody%20atmospheric%20lighting%20deep%20navy%20and%20warm%20amber%20tones%20soft%20film%20grain%20editorial%20photography%20no%20people&width=800&height=450&seq=wmzm-cover-01&orientation=landscape",
    duration: "12:48",
    year: 2026,
    category: "业余风",
    region: "日本",
    perspective: "男女合拍",
    tags: ["都市", "夜景", "手持拍摄"],
    uploadDate: "2026-10-15",
    views: 48210,
    resolution: "4K",
    description: "以深夜街道为背景的城市漫步记录，手持镜头跟随便利店的灯箱与雨后的路面，冷调霓虹与暖色招牌形成微妙对比。整体节奏松弛，适合喜欢都市氛围与自然叙事的观众。",
    featured: true,
  },
  {
    id: "v02",
    title: "雨落公寓的第37天",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20rain%20streaks%20on%20a%20large%20apartment%20window%20with%20sheer%20white%20curtain%20and%20soft%20morning%20light%20moody%20atmospheric%20lighting%20deep%20navy%20and%20warm%20amber%20tones%20soft%20film%20grain%20editorial%20photography%20no%20people&width=800&height=450&seq=wmzm-cover-02&orientation=landscape",
    duration: "18:20",
    year: 2026,
    category: "情侣自拍",
    region: "日本",
    perspective: "男女合拍",
    tags: ["室内", "雨天", "自然光"],
    uploadDate: "2026-10-13",
    views: 62140,
    resolution: "4K",
    description: "连续一个月记录同一扇窗外的天气变化，从梅雨到初晴，镜头以固定机位捕捉室内的光影流动。安静的日常记录，画面干净，声场细腻。",
    featured: false,
  },
  {
    id: "v03",
    title: "海边的夏日胶片存档",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20quiet%20seaside%20shoreline%20at%20dusk%20with%20gentle%20waves%20and%20warm%20sunset%20haze%20moody%20atmospheric%20lighting%20deep%20navy%20and%20warm%20amber%20tones%20soft%20film%20grain%20editorial%20photography%20no%20people&width=800&height=450&seq=wmzm-cover-03&orientation=landscape",
    duration: "09:36",
    year: 2026,
    category: "情侣自拍",
    region: "韩国",
    perspective: "男女合拍",
    tags: ["海边", "黄昏", "胶片感"],
    uploadDate: "2026-10-11",
    views: 38960,
    resolution: "1080P",
    description: "黄昏时分的海岸线记录，镜头跟随潮水退去的节奏缓慢移动，暖橘色天光与冷蓝海面层层过渡。全片以胶片模拟调色完成，适合大屏观看。",
    featured: false,
  },
  {
    id: "v04",
    title: "樱花与旧相机",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20an%20empty%20schoolyard%20with%20cherry%20blossom%20petals%20drifting%20in%20soft%20afternoon%20light%20moody%20atmospheric%20lighting%20deep%20navy%20and%20warm%20amber%20tones%20soft%20film%20grain%20editorial%20photography%20no%20people&width=800&height=450&seq=wmzm-cover-04&orientation=landscape",
    duration: "14:02",
    year: 2026,
    category: "校园风",
    region: "日本",
    perspective: "女性视角",
    tags: ["樱花", "校园", "复古"],
    uploadDate: "2026-10-09",
    views: 45720,
    resolution: "4K",
    description: "在樱花季结束前回到旧校园，用一台老式胶片相机重新走一遍走廊与操场。画面以低饱和处理，保留了胶片特有的颗粒与呼吸感。",
    featured: true,
  },
  {
    id: "v05",
    title: "首尔屋顶的黄昏六点",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20Seoul%20rooftop%20at%20golden%20hour%20with%20laundry%20lines%20and%20city%20skyline%20in%20warm%20haze%20moody%20atmospheric%20lighting%20deep%20navy%20and%20warm%20amber%20tones%20soft%20film%20grain%20editorial%20photography%20no%20people&width=800&height=450&seq=wmzm-cover-05&orientation=landscape",
    duration: "16:44",
    year: 2026,
    category: "素人系列",
    region: "韩国",
    perspective: "男女合拍",
    tags: ["城市屋顶", "黄昏", "生活感"],
    uploadDate: "2026-10-07",
    views: 55180,
    resolution: "4K",
    description: "记录首尔老城区一栋老公寓的屋顶日常，晾衣绳、水箱与远处逐渐亮起的城市灯光。没有剧本的即兴拍摄，画面自然，节奏舒服。",
    featured: false,
  },
  {
    id: "v06",
    title: "温泉旅馆的两小时",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20traditional%20Japanese%20ryokan%20wooden%20corridor%20with%20steam%20and%20warm%20paper%20lantern%20light%20moody%20atmospheric%20lighting%20deep%20navy%20and%20warm%20amber%20tones%20soft%20film%20grain%20editorial%20photography%20no%20people&width=800&height=450&seq=wmzm-cover-06&orientation=landscape",
    duration: "21:05",
    year: 2025,
    category: "温泉旅拍",
    region: "日本",
    perspective: "女性视角",
    tags: ["温泉", "木质建筑", "冬日"],
    uploadDate: "2026-10-05",
    views: 71340,
    resolution: "4K",
    description: "冬季山间温泉旅馆的完整记录，从玄关的木格栅到走廊尽头的雾气温泉，全程以自然光与纸灯照明拍摄。适合想要放松氛围的观众。",
    featured: true,
  },
  {
    id: "v07",
    title: "末班地铁前的十分钟",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20an%20empty%20subway%20platform%20at%20night%20with%20fluorescent%20lights%20and%20tiled%20walls%20moody%20atmospheric%20lighting%20deep%20navy%20and%20warm%20amber%20tones%20soft%20film%20grain%20editorial%20photography%20no%20people&width=800&height=450&seq=wmzm-cover-07&orientation=landscape",
    duration: "08:12",
    year: 2026,
    category: "业余风",
    region: "日本",
    perspective: "男性视角",
    tags: ["地铁", "夜晚", "纪实"],
    uploadDate: "2026-10-03",
    views: 29640,
    resolution: "1080P",
    description: "末班车到站前空旷的站台，灯管的白光与远处隧道的黑暗形成强烈层次。短片以环境音为主，几乎没有对白，像一段城市观察笔记。",
    featured: false,
  },
  {
    id: "v08",
    title: "窗帘缝里的晨光",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20hotel%20room%20with%20light%20beams%20through%20curtain%20gaps%20and%20warm%20dust%20particles%20moody%20atmospheric%20lighting%20deep%20navy%20and%20warm%20amber%20tones%20soft%20film%20grain%20editorial%20photography%20no%20people&width=800&height=450&seq=wmzm-cover-08&orientation=landscape",
    duration: "11:27",
    year: 2026,
    category: "素人系列",
    region: "韩国",
    perspective: "女性视角",
    tags: ["酒店", "晨光", "慢节奏"],
    uploadDate: "2026-09-30",
    views: 41380,
    resolution: "4K",
    description: "清晨六点的房间记录，光线从窗帘的缝隙里一点点铺到地板上。固定镜头加少量推轨，画面干净通透，几乎没有多余的剪辑。",
    featured: false,
  },
  {
    id: "v09",
    title: "雪国温泉的清晨",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20an%20outdoor%20rock%20onsen%20pool%20with%20falling%20snow%20and%20rising%20steam%20at%20dawn%20moody%20atmospheric%20lighting%20deep%20navy%20and%20warm%20amber%20tones%20soft%20film%20grain%20editorial%20photography%20no%20people&width=800&height=450&seq=wmzm-cover-09&orientation=landscape",
    duration: "17:53",
    year: 2025,
    category: "温泉旅拍",
    region: "日本",
    perspective: "男女合拍",
    tags: ["雪景", "温泉", "清晨"],
    uploadDate: "2026-09-28",
    views: 66720,
    resolution: "4K",
    description: "大雪过后的露天温泉，热气在零下的空气里缓慢上升。全片以长镜头为主，几乎没有剪辑点，安静得能听见雪落进水里。",
    featured: false,
  },
  {
    id: "v10",
    title: "棚拍灯下的三种情绪",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20an%20empty%20photo%20studio%20with%20softbox%20lights%20and%20seamless%20backdrop%20moody%20atmospheric%20lighting%20deep%20navy%20and%20warm%20amber%20tones%20soft%20film%20grain%20editorial%20photography%20no%20people&width=800&height=450&seq=wmzm-cover-10&orientation=landscape",
    duration: "23:41",
    year: 2026,
    category: "女优合集",
    region: "日本",
    perspective: "女性视角",
    tags: ["棚拍", "布光", "精选"],
    uploadDate: "2026-09-26",
    views: 88240,
    resolution: "4K",
    description: "同一套布光下完成的三组不同气质拍摄，从冷白硬光到暖调柔光，展示了光位变化对画面的影响。适合对摄影布光感兴趣的观众。",
    featured: true,
  },
  {
    id: "v11",
    title: "咖啡馆靠窗的第二个位置",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20cozy%20cafe%20window%20seat%20with%20a%20latte%20and%20warm%20afternoon%20sunlight%20through%20glass%20moody%20atmospheric%20lighting%20deep%20navy%20and%20warm%20amber%20tones%20soft%20film%20grain%20editorial%20photography%20no%20people&width=800&height=450&seq=wmzm-cover-11&orientation=landscape",
    duration: "13:18",
    year: 2026,
    category: "情侣自拍",
    region: "韩国",
    perspective: "男女合拍",
    tags: ["咖啡店", "午后", "约会感"],
    uploadDate: "2026-09-24",
    views: 36450,
    resolution: "1080P",
    description: "一个下午的咖啡馆记录，窗外的行人与杯口的雾气是主要画面元素。轻手持拍摄，光线随着太阳角度变化，自然又松弛。",
    featured: false,
  },
  {
    id: "v12",
    title: "化妆间的暖色灯泡",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20backstage%20vanity%20mirror%20with%20warm%20bulb%20lights%20and%20makeup%20brushes%20moody%20atmospheric%20lighting%20deep%20navy%20and%20warm%20amber%20tones%20soft%20film%20grain%20editorial%20photography%20no%20people&width=800&height=450&seq=wmzm-cover-12&orientation=landscape",
    duration: "10:54",
    year: 2025,
    category: "业余风",
    region: "日本",
    perspective: "女性视角",
    tags: ["后台", "暖光", "幕后"],
    uploadDate: "2026-09-22",
    views: 27180,
    resolution: "1080P",
    description: "演出前的化妆间记录，镜前的灯泡把整个空间染成琥珀色。镜头语言克制，更像一段幕后花絮。",
    featured: false,
  },
  {
    id: "v13",
    title: "夜行高速的路灯节奏",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20night%20highway%20lights%20seen%20through%20a%20rainy%20windshield%20with%20bokeh%20streaks%20moody%20atmospheric%20lighting%20deep%20navy%20and%20warm%20amber%20tones%20soft%20film%20grain%20editorial%20photography%20no%20people&width=800&height=450&seq=wmzm-cover-13&orientation=landscape",
    duration: "26:30",
    year: 2026,
    category: "业余风",
    region: "韩国",
    perspective: "男性视角",
    tags: ["公路", "夜景", "长镜头"],
    uploadDate: "2026-09-20",
    views: 33260,
    resolution: "4K",
    description: "一段从首尔开往海边的夜路，车灯与路灯以固定节奏掠过镜头。全片接近三十分钟，适合当作背景画面播放。",
    featured: false,
  },
  {
    id: "v14",
    title: "海嵴的篝火与潮声",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20small%20bonfire%20on%20a%20dark%20beach%20with%20glowing%20embers%20and%20blue%20twilight%20waves%20moody%20atmospheric%20lighting%20deep%20navy%20and%20warm%20amber%20tones%20soft%20film%20grain%20editorial%20photography%20no%20people&width=800&height=450&seq=wmzm-cover-14&orientation=landscape",
    duration: "19:12",
    year: 2025,
    category: "素人系列",
    region: "韩国",
    perspective: "男女合拍",
    tags: ["海边", "篝火", "夜色"],
    uploadDate: "2026-09-18",
    views: 44190,
    resolution: "4K",
    description: "夜宿海边的一晚，篝火的暖光与潮水的冷蓝在画面里互相映照。收音保留了完整的环境声，氛围感很强。",
    featured: false,
  },
  {
    id: "v15",
    title: "图书室最里面的一排",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20quiet%20library%20aisle%20with%20afternoon%20sunlight%20and%20dust%20in%20the%20air%20moody%20atmospheric%20lighting%20deep%20navy%20and%20warm%20amber%20tones%20soft%20film%20grain%20editorial%20photography%20no%20people&width=800&height=450&seq=wmzm-cover-15&orientation=landscape",
    duration: "15:08",
    year: 2026,
    category: "校园风",
    region: "日本",
    perspective: "女性视角",
    tags: ["图书室", "午后", "安静"],
    uploadDate: "2026-09-16",
    views: 31570,
    resolution: "1080P",
    description: "午后图书室的安静记录，阳光穿过书架的缝隙落在地板上。镜头运动极少，重点在声音与光线。",
    featured: false,
  },
  {
    id: "v16",
    title: "镜头前的第一支舞",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20dance%20studio%20with%20mirrors%20and%20late%20afternoon%20light%20across%20wooden%20floor%20moody%20atmospheric%20lighting%20deep%20navy%20and%20warm%20amber%20tones%20soft%20film%20grain%20editorial%20photography%20no%20people&width=800&height=450&seq=wmzm-cover-16&orientation=landscape",
    duration: "22:16",
    year: 2026,
    category: "女优合集",
    region: "韩国",
    perspective: "女性视角",
    tags: ["舞蹈", "镜面", "精选"],
    uploadDate: "2026-09-14",
    views: 79460,
    resolution: "4K",
    description: "练习室里的完整排练过程，镜面反射让画面层次更丰富。包含多个机位切换，节奏与音乐同步。",
    featured: false,
  },
  {
    id: "v17",
    title: "夏天最后一天的自行车道",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20narrow%20residential%20alley%20with%20a%20bicycle%20and%20summer%20greenery%20in%20warm%20light%20moody%20atmospheric%20lighting%20deep%20navy%20and%20warm%20amber%20tones%20soft%20film%20grain%20editorial%20photography%20no%20people&width=800&height=450&seq=wmzm-cover-17&orientation=landscape",
    duration: "11:44",
    year: 2025,
    category: "情侣自拍",
    region: "日本",
    perspective: "男女合拍",
    tags: ["夏日", "街道", "日常"],
    uploadDate: "2026-09-12",
    views: 28930,
    resolution: "1080P",
    description: "沿着河堤的自行车道骑到天黑，沿途记录蝉鸣、树影与便利店的招牌。轻快的日常向内容。",
    featured: false,
  },
  {
    id: "v18",
    title: "阳台上的晾衣绳与晚风",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20sunset%20balcony%20with%20hanging%20laundry%20and%20warm%20orange%20sky%20over%20a%20city%20moody%20atmospheric%20lighting%20deep%20navy%20and%20warm%20amber%20tones%20soft%20film%20grain%20editorial%20photography%20no%20people&width=800&height=450&seq=wmzm-cover-18&orientation=landscape",
    duration: "09:58",
    year: 2026,
    category: "业余风",
    region: "韩国",
    perspective: "男女合拍",
    tags: ["阳台", "晚风", "生活"],
    uploadDate: "2026-09-10",
    views: 24870,
    resolution: "1080P",
    description: "傍晚在阳台上待到天完全黑下来，晾着的衣物被风吹动，远处楼宇陆续亮灯。非常朴素的一段记录。",
    featured: false,
  },
  {
    id: "v19",
    title: "教室窗外的第三节课",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20an%20empty%20classroom%20with%20wooden%20desks%20and%20green%20trees%20outside%20the%20windows%20moody%20atmospheric%20lighting%20deep%20navy%20and%20warm%20amber%20tones%20soft%20film%20grain%20editorial%20photography%20no%20people&width=800&height=450&seq=wmzm-cover-19&orientation=landscape",
    duration: "12:36",
    year: 2026,
    category: "校园风",
    region: "日本",
    perspective: "男性视角",
    tags: ["教室", "夏天", "怀旧"],
    uploadDate: "2026-09-08",
    views: 30120,
    resolution: "1080P",
    description: "暑假空置的教室，风扇缓慢转动，树影在课桌上移动。以极简的固定镜头呈现一段安静的午后。",
    featured: false,
  },
  {
    id: "v20",
    title: "公园长椅上的整个秋天",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20an%20empty%20park%20bench%20under%20autumn%20trees%20with%20fallen%20leaves%20moody%20atmospheric%20lighting%20deep%20navy%20and%20warm%20amber%20tones%20soft%20film%20grain%20editorial%20photography%20no%20people&width=800&height=450&seq=wmzm-cover-20&orientation=landscape",
    duration: "20:22",
    year: 2025,
    category: "素人系列",
    region: "韩国",
    perspective: "女性视角",
    tags: ["秋天", "公园", "慢记录"],
    uploadDate: "2026-09-06",
    views: 35840,
    resolution: "4K",
    description: "在同一个公园长椅连续拍摄了六周，记录树叶从金黄到落尽的全过程。时间流逝感是这支短片的主题。",
    featured: false,
  },
  {
    id: "v21",
    title: "雾中山道的温泉巴士",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20foggy%20mountain%20road%20with%20dense%20mist%20and%20pine%20trees%20in%20early%20morning%20light%20moody%20atmospheric%20lighting%20deep%20navy%20and%20warm%20amber%20tones%20soft%20film%20grain%20editorial%20photography%20no%20people&width=800&height=450&seq=wmzm-cover-21&orientation=landscape",
    duration: "18:48",
    year: 2026,
    category: "温泉旅拍",
    region: "日本",
    perspective: "男女合拍",
    tags: ["山道", "雾", "旅途"],
    uploadDate: "2026-09-04",
    views: 47630,
    resolution: "4K",
    description: "清晨搭上开往山间温泉的巴士，窗外全是雾与松林。以旅途本身为主线，包含下车后的散步片段。",
    featured: false,
  },
  {
    id: "v22",
    title: "镜面房间的黄昏独白",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20dim%20room%20with%20a%20large%20mirror%20and%20warm%20dusk%20light%20across%20the%20wall%20moody%20atmospheric%20lighting%20deep%20navy%20and%20warm%20amber%20tones%20soft%20film%20grain%20editorial%20photography%20no%20people&width=800&height=450&seq=wmzm-cover-22&orientation=landscape",
    duration: "16:10",
    year: 2026,
    category: "女优合集",
    region: "日本",
    perspective: "女性视角",
    tags: ["镜面", "黄昏", "艺术感"],
    uploadDate: "2026-09-02",
    views: 58210,
    resolution: "4K",
    description: "以一面落地镜为核心构图的室内短片，黄昏的光缓慢移动，画面在反射中层层叠加。视觉完成度很高。",
    featured: false,
  },
  {
    id: "v23",
    title: "河堤烟花的十分钟",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20fireworks%20over%20a%20river%20at%20night%20with%20reflections%20on%20water%20and%20crowd%20silhouettes%20far%20away%20moody%20atmospheric%20lighting%20deep%20navy%20and%20warm%20amber%20tones%20soft%20film%20grain%20editorial%20photography%20no%20people&width=800&height=450&seq=wmzm-cover-23&orientation=landscape",
    duration: "10:02",
    year: 2026,
    category: "情侣自拍",
    region: "日本",
    perspective: "男女合拍",
    tags: ["烟花", "河堤", "夏夜"],
    uploadDate: "2026-08-31",
    views: 51470,
    resolution: "4K",
    description: "夏末花火大会的现场记录，河面上的倒影与人群的剪影构成画面层次。收音保留了现场的环境声。",
    featured: false,
  },
  {
    id: "v24",
    title: "凌晨厨房的一碗面",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20warm%20late%20night%20kitchen%20with%20steam%20over%20a%20pot%20and%20soft%20under%20cabinet%20lighting%20moody%20atmospheric%20lighting%20deep%20navy%20and%20warm%20amber%20tones%20soft%20film%20grain%20editorial%20photography%20no%20people&width=800&height=450&seq=wmzm-cover-24&orientation=landscape",
    duration: "08:44",
    year: 2026,
    category: "业余风",
    region: "韩国",
    perspective: "男女合拍",
    tags: ["厨房", "深夜", "治愈"],
    uploadDate: "2026-08-29",
    views: 22760,
    resolution: "1080P",
    description: "凌晨两点的小厨房，煮一碗面，等水开的时间被完整保留。非常生活化的固定机位记录。",
    featured: false,
  },
  {
    id: "v25",
    title: "韩屋巷子里的午后",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20traditional%20Korean%20hanok%20village%20alley%20with%20tiled%20roofs%20in%20soft%20afternoon%20sunlight%20moody%20atmospheric%20lighting%20deep%20navy%20and%20warm%20amber%20tones%20soft%20film%20grain%20editorial%20photography%20no%20people&width=800&height=450&seq=wmzm-cover-25&orientation=landscape",
    duration: "14:26",
    year: 2026,
    category: "素人系列",
    region: "韩国",
    perspective: "女性视角",
    tags: ["韩屋", "老城区", "午后"],
    uploadDate: "2026-08-27",
    views: 39460,
    resolution: "4K",
    description: "在保留完整的韩屋巷子里散步，瓦顶、石墙与窄巷的阴影层次丰富。整体色调偏暖，画面质感细腻。",
    featured: false,
  },
  {
    id: "v26",
    title: "雪夜小木屋的窗",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20snowy%20cabin%20window%20at%20night%20with%20warm%20interior%20glow%20and%20snowfall%20outside%20moody%20atmospheric%20lighting%20deep%20navy%20and%20warm%20amber%20tones%20soft%20film%20grain%20editorial%20photography%20no%20people&width=800&height=450&seq=wmzm-cover-26&orientation=landscape",
    duration: "19:34",
    year: 2025,
    category: "温泉旅拍",
    region: "日本",
    perspective: "男女合拍",
    tags: ["雪夜", "木屋", "安静"],
    uploadDate: "2026-08-25",
    views: 42980,
    resolution: "4K",
    description: "雪夜里的小木屋，室内是暖黄的灯光，窗外是不断落下的雪。全片几乎没有对白，只有炉火与风声。",
    featured: false,
  },
  {
    id: "v27",
    title: "祭典灯笼下的两小时",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20Japanese%20festival%20street%20lined%20with%20red%20paper%20lanterns%20at%20night%20moody%20atmospheric%20lighting%20deep%20navy%20and%20warm%20amber%20tones%20soft%20film%20grain%20editorial%20photography%20no%20people&width=800&height=450&seq=wmzm-cover-27&orientation=landscape",
    duration: "21:48",
    year: 2026,
    category: "女优合集",
    region: "日本",
    perspective: "男女合拍",
    tags: ["祭典", "灯笼", "夜景"],
    uploadDate: "2026-08-23",
    views: 63820,
    resolution: "4K",
    description: "夏季祭典的完整街拍记录，红灯笼把整条街道染成暖橘色。镜头与人流一起移动，临场感很强。",
    featured: false,
  },
  {
    id: "v28",
    title: "唱片室里的一盏台灯",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20small%20vinyl%20record%20room%20with%20a%20single%20desk%20lamp%20and%20warm%20shadows%20moody%20atmospheric%20lighting%20deep%20navy%20and%20warm%20amber%20tones%20soft%20film%20grain%20editorial%20photography%20no%20people&width=800&height=450&seq=wmzm-cover-28&orientation=landscape",
    duration: "15:52",
    year: 2025,
    category: "女优合集",
    region: "韩国",
    perspective: "女性视角",
    tags: ["唱片", "台灯", "深夜"],
    uploadDate: "2026-08-21",
    views: 34690,
    resolution: "1080P",
    description: "深夜的唱片室，一张一张换着听完整张专辑。画面只有一盏台灯，声音是绝对的主角。",
    featured: false,
  },
];